import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { getRequest, postRequest } from '@/api/request'
import Vant from 'vant'
import 'vant/lib/index.css'
import './assets/rem'

Vue.use(Vant)
Vue.config.productionTip = false
Vue.prototype.$post = postRequest
Vue.prototype.$get = getRequest

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js